import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'shared/i18n'
import ViewTermsOfUse from './view'

export default function TermsOfUsePage (): JSX.Element {
  const { t } = useTranslation()
  return (
    <>
      <Helmet>
        <title>{t('termsOfUse.termsOfUse.text')}</title>
      </Helmet>

      <ViewTermsOfUse />
    </>
  )
}
